import { getUserMissions } from "@/actions/mission";
import { surveySortOrderAtom } from "@/atoms/me/searchAtoms";
import { missionQueryKeys } from "@/constants/queryKeys/missionQueryKeys";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

export const useReadMissions = (params?: {
  options?: {
    userId?: string;
    limit?: number;
  };
}) => {
  const sortOrder = useAtomValue(surveySortOrderAtom);

  return useInfiniteQuery({
    queryKey: missionQueryKeys.userMissions(params?.options?.userId),
    queryFn: ({ pageParam }) => {
      return getUserMissions({
        cursor: pageParam,
        limit: params?.options?.limit ?? 10,
        sortOrder,
      });
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export type UseReadSurveysReturn = ReturnType<typeof useReadMissions>;
